"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalConfigForPage = void 0;
const tslib_1 = require("tslib");
const isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
const merge_1 = tslib_1.__importDefault(require("lodash/merge"));
/**
 * Get configuration from contentful JSON. If overrides are defined
 * that match the current path or are defined in the globalConfigOverride cookie
 * then apply the overrides to default globals.
 *
 * @deprecated - This function is deprecated; use unleash for feature toggles
 * @param {object} rawConfig
 * @param {object} globalConfigOverrideCookie
 * @param {string} currPath
 * @returns {object} - config object
 */
const getGlobalConfigForPage = (rawConfig, globalConfigOverrideCookie, currPath) => {
    if (!rawConfig) {
        return {};
    }
    const { pages } = rawConfig, rootConfig = tslib_1.__rest(rawConfig
    // If the cookie does not exist then getGlobalConfigOverrideCookie will return an empty object
    , ["pages"]);
    // If the cookie does not exist then getGlobalConfigOverrideCookie will return an empty object
    if (!(0, isEmpty_1.default)(globalConfigOverrideCookie)) {
        // apply overrides to the keys specified in the globalConfigOverride cookie if it exists
        (0, merge_1.default)(rootConfig, globalConfigOverrideCookie);
    }
    else if (Array.isArray(pages)) {
        // apply page specific overrides if there is a match
        for (const page of pages) {
            const { pattern, value } = page;
            if (value && currPath && currPath.includes(pattern)) {
                (0, merge_1.default)(rootConfig, value);
            }
        }
    }
    return rootConfig;
};
exports.getGlobalConfigForPage = getGlobalConfigForPage;
exports.default = exports.getGlobalConfigForPage;
//# sourceMappingURL=getGlobalConfigForPage.js.map